import {Controller} from "@hotwired/stimulus"
import {post} from "@rails/request.js"

export default class extends Controller {
  static targets = ["statusText", "camera",
    "clockText", "clockType", "buttonContainer", "clockButton",
    "cameraContainer", "currentClockType", "project"]
  static values = {
    employeeId: Number,
    assigneeId: Number,
    clockType: String,
    canClockIn: {type: Boolean, default: false},
    canClockOut: {type: Boolean, default: false},
    clockedIn: {type: Boolean, default: false},
  }

  connect() {
    this.stream = null;
    this.lastPosition = null;
    // this.lastPosition = {lat: 0,lng: 0};

    this.initailState = this.getInitialState();

    this.setState(this.initailState);

    this.initEvents();

    this.getLocation();
  }

  get states() {
    return {
      'clockIn': {
        text: 'CLOCK IN',
        type: this.clockTypeValue,
        className: this.clockTypeValue == 'overtime' ? 'overtime' : '',
        statusText: 'Not clocked in'
      },
      'clockedIn': {
        text: 'CLOCK OUT',
        type: this.clockTypeValue,
        className: 'd-none',
        statusText: 'Clocked in ✅'
      },
      'clockOut': {
        text: 'CLOCK OUT',
        type: this.clockTypeValue,
        className: 'clocked-in',
        statusText: 'Clocked in ✅'
      },
      'noClock': {
        text: '',
        type: '',
        className: 'd-none',
        statusText: 'Out of work'
      }
    }
  }

  getInitialState() {
    if (this.canClockOutValue) {
      return 'clockOut';
    } else if (this.clockedInValue) {
      return 'clockedIn';
    } else if (this.canClockInValue) {
      return 'clockIn';
    } else {
      return 'noClock'
    }
  }

  setState(state) {
    const config = this.states[state];

    // Update button text and type
    this.clockTextTarget.textContent = config.text;
    this.clockTypeTarget.textContent = config.type;
    this.statusTextTarget.textContent = config.statusText;

    // Update container class
    this.buttonContainerTarget.className = 'glow-container ' + config.className;
  }

  handelClock() {
    if (this.clockedInValue) {
      this.showConfirmation();
    } else {
      this.openCamera()
    }
  }

  afterClockIn() {
    this.clockButtonTarget.style.transform = 'scale(0.95)';

    setTimeout(() => {
      // Automatically switch to clocked-in state
      this.setState('clockedIn');

      this.clockButtonTarget.style.transform = '';
      greenPOS.notify_success('Clocked in successfully!');
    }, 150);
  }

  confirmClockOut() {
    this.hideConfirmation();
    this.openCamera();
  }

  afterClockOut() {
    this.setState('noClock');

    greenPOS.notify_success('Clocked out successfully!');
  }

  async openCamera() {
    this.hideClockButton();

    try {
      this.stream = await navigator.mediaDevices.getUserMedia({video: true});
      this.cameraTarget.srcObject = this.stream;
    } catch (error) {
      // this.showClockButton();
      greenPOS.notify_error("Camera access denied or not available");
    }
  }

  sendImage() {
    let imageData;

    if (this.stream) {
      const canvas = document.createElement("canvas");
      const context = canvas.getContext("2d");

      // Set canvas size to video size
      canvas.width = this.cameraTarget.videoWidth;
      canvas.height = this.cameraTarget.videoHeight;

      // Draw current video frame to canvas
      context.drawImage(this.cameraTarget, 0, 0, canvas.width, canvas.height);

      // Convert to Base64 PNG
      imageData = canvas.toDataURL("image/png");

      this.stopCamera();
      this.cameraTarget.classList.add('d-none');
    } else {
      console.log('No camera access denied or not available');
    }

    this.sendClockAction(imageData);
  }

  stopCamera() {
    this.stream && this.stream.getTracks().forEach(track => track.stop());
  }

  async sendClockAction(imageData) {
    // console.log(imageData);
    if (!this.lastPosition) {
      greenPOS.notify_error('Can not access location');
      this.showClockButton();
      return;
    }

    if (!imageData) {
      greenPOS.notify_error('No image data.');
      this.showClockButton();
      return;
    }

    let url = `/hr/employee_attendance/${this.action === "in" ? "clock_in" : "clock_out"}`;

    const body = {
      employee_id: this.employeeIdValue,
      assignee_id: this.assigneeIdValue,
      lat: this.lastPosition.lat,
      lng: this.lastPosition.lng,
      avatar: imageData
    };

    try {
      const response = await post(url, {'responseKind': 'turbo-stream', body});
      // console.log(response)

      if (response.ok) {
        // await response.renderTurboStream()
      } else {
      }
    } catch (e) {
      greenPOS.notify_error(e);
      this.showClockButton();
    }
  }

  get action() {
    return this.clockedInValue ? 'out' : 'in';
  }

  // Get GPS position
  getLocation() {
    if (!'geolocation' in navigator) {
      return;
    }

    navigator.geolocation.getCurrentPosition(
      pos => {
        this.lastPosition = {lat: pos.coords.latitude, lng: pos.coords.longitude};
      },
      err => {
        console.warn("GPS error:", err);
      }
    );
  }

  initEvents() {
    // Add keyboard support
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        this.handelClock();
      }
      if (e.key === 'Escape') {
        this.hideConfirmation();
      }
    });

    // Add a subtle startup animation delay
    setTimeout(() => {
      this.buttonContainerTarget.style.animation = 'none';
    }, 1000);
  }

  showConfirmation() {
    document.getElementById('confirmationPopup').style.display = 'flex';
  }

  hideConfirmation() {
    document.getElementById('confirmationPopup').style.display = 'none';
  }

  hideClockButton() {
    this.buttonContainerTarget.classList.add('d-none');
    this.showCameraContainer()
  }

  showClockButton() {
    this.buttonContainerTarget.classList.remove('d-none');
    this.hideCameraContainer();
  }

  showCameraContainer() {
    this.cameraContainerTarget.classList.remove('d-none');
  }

  hideCameraContainer() {
    this.cameraContainerTarget.classList.add('d-none');
  }

  get projectIcon() {
    return '<i class="building outline icon"></i>'
  }
};
